import { PHONE, locationSchema } from "../structured-data-core";

export function getAtlantaStructuredData() {
  const url = "https://restorehair.com/locations/georgia/atlanta/";
  const description =
    "Find out about your hair transplant options in Atlanta with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Atlanta", "1201 Peachtree Street, Suite 200", "Atlanta", "GA", PHONE, url, description),
  ];
}
